import React from "react";
import { observer } from "mobx-react";
import { InsuranceOrderingListTemplate } from "themes/application/insurance-ordering/pages";
import { InsuranceOrderingListViewStore } from "application/insurance-ordering/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new InsuranceOrderingListViewStore(rootStore), "insuranceOrderingListViewStore")
@observer
class InsuranceOrderingList extends React.Component {
	render() {
		return <InsuranceOrderingListTemplate {...this.props} />;
	}
}

export default InsuranceOrderingList;